module.exports = {
    SELECT_CAPTCHA_WRAPPER: 'captcha-wrapper',
    SELECT_SIGNUP_FORM: 'signup-form',
    SELECT_LOGIN_FORM: 'login-form',
    SELECT_EDIT_EMAIL_FORM: 'edit-email-form',
    SELECT_SETTINGS_FORM: 'settings-form',
    SELECT_PASSWORD_FORM: 'password-form',
    SELECT_NEW_PASSWORD_FORM: 'remember-password-form',
    SELECT_SIGNUP_FB_FORM: 'signup-fb-form',
    SUCCESS: 'SUCCESS',
    EVENT_ITEM_REMOVED_FROM_WISHLIST_PAGE: 'itemRemovedFromWishlistPage'
};
